import { createUrl, getObject, getObjects, patchObject, postObject, putObject, REACT_APP_API_URL } from "../Common/js/api_common"

export const ENDPOINT_RESPONSE_CHOICES = "/api/response_choices"

export async function getResponseChoices(parameters = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_RESPONSE_CHOICES
  const defaultParameters = {}
  url = createUrl(url, parameters, defaultParameters)
  return await getObjects(url)
}

export async function getResponseChoice(id) {
  let url = REACT_APP_API_URL + ENDPOINT_RESPONSE_CHOICES + "/" + id
  return await getObject(url)
}

export async function putResponseChoice(id, putValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_RESPONSE_CHOICES + "/" + id
  return await putObject(url, putValues)
}

export async function patchResponseChoice(id, patchValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_RESPONSE_CHOICES + "/" + id
  return await patchObject(url, patchValues)
}

export async function postResponseChoice(postValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_RESPONSE_CHOICES
  return await postObject(url, postValues)
}
